import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import getValueWithDotNotation from 'get-value'
import setValueWithDotNotation from 'set-value'
import i18n from '@/lang/lang'

export const toLocaleUpperCase = (str) => {
  return str?.toLocaleUpperCase(i18n.locale) || ''
}

export const toLocaleLowerCase = (str) => {
  return str?.toLocaleLowerCase(i18n.locale) || ''
}

/**
 *
 * @param obj {Object}: The object to set value on
 * @param path {String|Array}: The path of the property to set.
 * @param options {Object}: See all available options https://github.com/jonschlinkert/get-value#options
 * @returns {*}
 */
export const getPropValueWithDotNotation = (obj, path, options) => {
  return getValueWithDotNotation(obj, path, options)
}
/**
 *
 * @param obj {Object}: The object to set value on
 * @param path {String|Array}: The path of the property to set.
 * @param value {Any}: The value to set on obj[prop]
 * @param options {Object}: See all available options https://github.com/jonschlinkert/set-value#options
 */
export const setPropValueWithDotNotation = (obj, path, value, options) => {
  setValueWithDotNotation(obj, path, value)
}

export const toLocaleTitleCase = (str) => {
  return str.split(' ').map(x => toLocaleUpperCase(x.charAt(0)) + toLocaleLowerCase(x.slice(1))).join(' ')
}

export const numberMask = createNumberMask({
  prefix                   : '',
  suffix                   : '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol : ',',
  allowDecimal             : true,
  decimalSymbol            : '.',
  decimalLimit             : 2,
  integerLimit             : null,
  requireDecimal           : false,
  allowNegative            : false,
  allowLeadingZeroes       : false
})

export const formatVuetifyDate = (date) => {
  if (!date) return ''

  const [year, month, day] = date.split('-')
  return `${day}/${month}/${year}`
}

export const parseVuetifyDate = (date) => {
  if (!date) return ''

  const [day, month, year] = date.split('/')
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}

/**
 * Generate a time mask based on input value (23:59)
 * @param {string} value
 * @returns {(RegExp|string)[]|RegExp[]}
 */
export const timeMask = (value) => {
  const hours = [
    /[0-2]/,
    value.charAt(0) === '2' ? /[0-3]/ : /[0-9]/
  ]
  const minutes = [/[0-5]/, /[0-9]/]
  return value.length > 2 ? [...hours, ':', ...minutes] : hours
}

/**
 * Generate a date mask (16/12/2021)
 * @param {string} value
 * @returns {[RegExp, string, RegExp, string, RegExp]}
 */
export const dateSlashMask = (value) => {
  const day = [/[0-3]/, value.charAt(0) === '0' ? /[1-9]/ : value.charAt(0) === '1' || value.charAt(0) === '2' ? /[0-9]/ : /[01]/]
  const month = [/[0-1]/, value.charAt(3) === '0' ? /[1-9]/ : /[0-2]/]
  const year = [/[12]/, value.charAt(6) === '2' ? /[0]/ : /[9]/, /[0-9]/, /[0-9]/]
  return [...day, '/', ...month, '/', ...year]
}

/**
 * Generate a date mask (16-12-2021)
 * @param {string} value
 * @returns {[RegExp, string, RegExp, string, RegExp]}
 */
export const dateDashMask = (value) => {
  const day = [/[0-3]/, value.charAt(0) === '0' ? /[1-9]/ : value.charAt(0) === '1' || value.charAt(0) === '2' ? /[0-9]/ : /[01]/]
  const month = [/[0-1]/, value.charAt(3) === '0' ? /[1-9]/ : /[0-2]/]
  const year = [/[12]/, value.charAt(6) === '2' ? /[0]/ : /[9]/, /[0-9]/, /[0-9]/]
  return [...day, '-', ...month, '-', ...year]
}

export const floatNumber = (value) => parseFloat(parseFloat(value).toFixed(2))
